import PropTypes from 'prop-types';

import Colors from '../utils/colors';

import WhatsappIcon from '../icons/WhatsappIcon';
import FacebookIcon from '../icons/FacebookIcon';
import MessengerIcon from '../icons/MessengerIcon';
import EmailIcon from '../icons/EmailIcon';
import TwitterIcon from '../icons/TwitterIcon';
import LinkedInIcon from '../icons/LinkedIn';
import RoundButtonWithIcon from '../RoundButtonWithIcon';

import styles from './SharingMethods.module.scss';

const sharingMethodIcons = {
  whatsapp: { backgroundColor: '#25d366', icon: <WhatsappIcon /> },
  messenger: { backgroundColor: '#0096ff', icon: <MessengerIcon /> },
  email: { backgroundColor: Colors.primary, icon: <EmailIcon /> },
  facebook: {
    backgroundColor: '#4267b2',
    icon: <FacebookIcon size={'big'} />
  },
  twitter: { backgroundColor: '#5f9fef', icon: <TwitterIcon fill={'#FFF'} /> },
  linkedIn: { backgroundColor: '#2867b2', icon: <LinkedInIcon fill={'#FFF'} /> }
};

const SharingMethods = ({ title = '', methods, onClick }) => (
  <div className={styles.sharingContainer}>
    {title && <p className={styles.title}>{title}</p>}
    <div className={styles.iconsContainer}>
      {methods.map(method =>
        sharingMethodIcons[method] ? (
          <div className={styles.iconContainer} key={method}>
            <RoundButtonWithIcon
              type={method}
              backgroundColor={sharingMethodIcons[method].backgroundColor}
              className={styles.icon}
              onClick={() => onClick(method)}
            >
              {sharingMethodIcons[method].icon}
            </RoundButtonWithIcon>
          </div>
        ) : null
      )}
    </div>
  </div>
);

SharingMethods.types = {
  whatsapp: 'whatsapp',
  messenger: 'messenger',
  email: 'email',
  facebook: 'facebook',
  twitter: 'twitter',
  linkedIn: 'linkedIn'
};

SharingMethods.propTypes = {
  title: PropTypes.string,
  methods: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(SharingMethods.types)))
    .isRequired,
  onClick: PropTypes.func.isRequired
};

export default SharingMethods;
